export const isObjectString = (str: string): boolean => {
  try {
    const parsed = JSON.parse(str);
    return (
      typeof parsed === "object" && parsed !== null && !Array.isArray(parsed)
    );
  } catch (e) {
    return false;
  }
};
